<template>
  <div class="ss-root">
    <div class="ss-card">

      <div v-if="loading" class="ss-loading">
        <div class="ss-spinner"></div>
        <p>{{ tr.activating }}</p>
      </div>

      <div v-else-if="error" class="ss-error">
        <div style="font-size:48px">❌</div>
        <h2>{{ tr.errorTitle }}</h2>
        <p>{{ error }}</p>
        <button class="ss-btn ss-btn-secondary" @click="$router.push('/pricing')">← {{ tr.back }}</button>
      </div>

      <div v-else class="ss-success">
        <div class="ss-icon">✅</div>
        <h1>{{ tr.title }}</h1>
        <p>{{ tr.subtitle }} <strong>{{ planLabel }}</strong></p>
        <button class="ss-btn ss-btn-primary" @click="$router.push('/dashboard')">{{ tr.cta }}</button>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const PLAN_LABELS = {
  starter: 'Plus ⭐',
  pro:     'Premium 🏆',
};

const VALID_PLANS = ['starter', 'pro'];

const TRANSLATIONS = {
  fr: {
    activating:  'Activation de votre abonnement…',
    title:       'Abonnement activé !',
    subtitle:    'Votre plan',
    cta:         'Aller au tableau de bord →',
    errorTitle:  'Une erreur est survenue',
    errorNoUser: 'Vous devez être connecté pour activer un abonnement.',
    errorBadPlan:'Plan inconnu. Contactez le support.',
    back:        'Retour à la page des plans',
  },
  en: {
    activating:  'Activating your subscription…',
    title:       'Subscription activated!',
    subtitle:    'Your plan',
    cta:         'Go to dashboard →',
    errorTitle:  'An error occurred',
    errorNoUser: 'You must be logged in to activate a subscription.',
    errorBadPlan:'Unknown plan. Please contact support.',
    back:        'Back to plans',
  },
  he: {
    activating:  'מפעיל את המנוי שלך…',
    title:       'המנוי הופעל!',
    subtitle:    'התוכנית שלך',
    cta:         'עבור ללוח הבקרה →',
    errorTitle:  'אירעה שגיאה',
    errorNoUser: 'עליך להיות מחובר כדי להפעיל מנוי.',
    errorBadPlan:'תוכנית לא מוכרת. צור קשר עם התמיכה.',
    back:        'חזרה לדף התוכניות',
  },
};

export default {
  data() {
    return {
      loading:   true,
      error:     null,
      planLabel: '',
      lang: localStorage.getItem('adminLang') || 'fr',
    };
  },

  computed: {
    tr() { return TRANSLATIONS[this.lang] || TRANSLATIONS.fr; },
  },

  async mounted() {
    const plan = this.$route.query.plan;

    if (!VALID_PLANS.includes(plan)) {
      this.error = this.tr.errorBadPlan;
      this.loading = false;
      return;
    }

    await new Promise(resolve => {
      const unsub = firebase.auth().onAuthStateChanged(async user => {
        unsub();
        if (!user) {
          this.error = this.tr.errorNoUser;
          this.loading = false;
          resolve();
          return;
        }
        try {
          await firebase.database().ref('users/' + user.uid + '/plan').set(plan);
          this.planLabel = PLAN_LABELS[plan];
        } catch (e) {
          this.error = e.message;
        }
        this.loading = false;
        resolve();
      });
    });
  },
};
</script>

<style scoped>
* { box-sizing: border-box; }

.ss-root {
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f4f8 0%, #e8f0fe 100%);
  display: flex; align-items: center; justify-content: center;
  font-family: system-ui, sans-serif; padding: 24px;
}
.ss-card {
  background: white; border-radius: 20px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.1);
  padding: 48px 40px; max-width: 480px; width: 100%;
  text-align: center;
}
.ss-loading { display: flex; flex-direction: column; align-items: center; gap: 16px; }
.ss-spinner {
  width: 48px; height: 48px;
  border: 4px solid #e2e8f0; border-top-color: #1a73e8;
  border-radius: 50%; animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
.ss-loading p { color: #64748b; font-size: 15px; }
.ss-icon { font-size: 64px; margin-bottom: 16px; }
.ss-success h1 { font-size: 28px; font-weight: 800; color: #1e293b; margin: 0 0 12px; }
.ss-success p  { font-size: 16px; color: #475569; margin: 0 0 28px; }
.ss-error { display: flex; flex-direction: column; align-items: center; gap: 12px; }
.ss-error h2 { color: #dc2626; margin: 0; }
.ss-error p  { color: #64748b; font-size: 14px; }
.ss-btn {
  padding: 14px 28px; border-radius: 10px;
  font-size: 15px; font-weight: 700; border: none; cursor: pointer;
}
.ss-btn-primary  { background: #1a73e8; color: white; }
.ss-btn-primary:hover { background: #1557b0; }
.ss-btn-secondary { background: #f1f5f9; color: #475569; }
.ss-btn-secondary:hover { background: #e2e8f0; }
</style>
